export const DOMAIN_ACL_OBJECTS = [
    'DomainNew',
    'DomainList',
    'DomainDetail'
];
